// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/checkbox-circle.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Summary_response-message__lvsYi {
  margin-bottom: 30px;
}

.Summary_card__nJ1DD {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 12px;
  border: 1px solid #4343ff;
  background: #fff;
  margin-bottom: 20px;
}

.Summary_card-top__\\+uCuN {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 12px 0;
  border-radius: 12px 12px 0 0;
  background: #4343ff;
  color: #fff;
}
.Summary_card-top__\\+uCuN .Summary_price-description__zYvzK {
  font-weight: 400;
  font-size: 20px;
  line-height: 36px;
}
.Summary_card-top__\\+uCuN .Summary_price-month__Fmh9y {
  position: relative;
  font-weight: 400;
  font-size: 28px;
  line-height: 48px;
}
.Summary_card-top__\\+uCuN .Summary_price-month__Fmh9y span {
  font-weight: 600;
  font-size: 52px;
  line-height: 84px;
}
.Summary_card-top__\\+uCuN .Summary_price-year__MVFvi {
  font-weight: 300;
  font-size: 14px;
  line-height: 24px;
}

.Summary_card-content__aChOt {
  padding: 16px 28px 20px;
}

.Summary_summary__rpLY8 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-top: 8px;
  border-radius: 12px;
  color: #00007a;
}
.Summary_summary-title__t-DAI {
  color: #00007a;
  font-size: 16px;
  font-weight: 500;
  line-height: 28px;
}
.Summary_summary-title__t-DAI svg {
  vertical-align: middle;
}
.Summary_summary-description__cGsWz {
  font-size: 16px;
  font-weight: 300;
  line-height: 28px;
}
.Summary_summary-start-date__wdfvT {
  font-weight: 400;
  margin-left: 25px;
}

.Summary_address__itBSB {
  display: flex;
  justify-content: space-between;
}
.Summary_address-link__Yiw5b a {
  color: #4343ff !important;
}

.Summary_payment__SuQAL {
  width: 100%;
  margin: 25px 0;
}
.Summary_payment-title__nOQWk {
  margin-bottom: 16px;
  font-weight: 500;
  font-size: 20px;
  line-height: 36px;
  color: #00007a;
}
.Summary_payment-methods__PhP\\+Z {
  display: grid;
  grid-auto-flow: column;
  gap: 12px;
  grid-template-columns: 1fr 1fr;
}
.Summary_payment-method__UrHXg {
  padding: 20px 12px;
  border-radius: 8px;
  border: 1px solid #d8d8ff;
  text-align: center;
  background: #fff;
  cursor: pointer;
}
.Summary_payment-method__UrHXg.Summary_selected__xVU1u {
  background: #4343ff;
}
.Summary_payment-method__UrHXg.Summary_selected__xVU1u p {
  color: #fff;
}
.Summary_payment-method__UrHXg p {
  font-size: 16px;
  line-height: 28px;
}

.Summary_checkbox__6LMly {
  width: 100%;
}
.Summary_checkbox-label__IrtcN {
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  color: #00007a;
}

.Summary_link__20gJv a,
.Summary_link__20gJv a:visited {
  color: #00007a;
  text-decoration: underline;
}

.Summary_collapsible__sIwmU {
  padding: 0;
  width: 100%;
  font-size: 16px;
  background: none;
}
.Summary_collapsible__sIwmU div {
  align-items: normal;
}
.Summary_collapsible__sIwmU div div {
  position: initial;
  margin-right: 5px;
  margin-top: 3px;
}
.Summary_collapsible__sIwmU div > span {
  position: absolute;
  right: 0;
}
.Summary_collapsible__sIwmU div h4 span {
  font-size: 16px !important;
}
.Summary_collapsible__sIwmU div:last-child {
  margin: 0 !important;
  padding-left: 25px;
}
.Summary_collapsible__sIwmU div:last-child ul {
  margin: 0;
}

.Summary_list__K-TaM {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-weight: 300;
  font-size: 16px;
  line-height: 28px;
  padding: 0;
}
.Summary_list-title__LnW\\+w {
  font-weight: 400;
  font-size: 20px;
  line-height: 1.5;
  color: #00007a;
}

.Summary_item__V4LbE {
  display: flex;
  align-items: baseline;
}
.Summary_item__V4LbE:before {
  content: "";
  display: inline-block;
  width: 17px;
  min-width: 17px;
  height: 17px;
  margin-right: 10px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  vertical-align: top;
  transform: translateY(4px);
}

.Summary_payment-start__39xjR {
  display: block;
  margin: -20px auto 20px auto;
  font-size: 16px;
  font-weight: 300;
  color: #00007a;
}

.Summary_legal-terms__kAA0J {
  font-size: 10px;
  font-weight: 300;
  line-height: 16px;
  color: #00007a;
  margin-top: 20px;
  margin-bottom: -20px;
}

.Summary_offer__qy\\+sn {
  padding: 20px 28px;
}
.Summary_offer__qy\\+sn:nth-child(3) {
  border-top: 1px solid #4343ff;
}

@media screen and (max-width: 600px) {
  .Summary_card-content__aChOt {
    padding: 16px;
  }
  .Summary_payment-method__UrHXg {
    padding-left: 20px;
    padding-right: 20px;
  }
  .Summary_inputs__k2g-G {
    margin-bottom: 32px;
  }
  .Summary_button__kqcfi {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Freemium/Summary/Summary.module.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAGA;EACE,mBAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AAIF;;AADA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,4BAAA;EACA,mBCtBS;EDuBT,WAAA;AAIF;AAFE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAIJ;AADE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAGJ;AADI;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AAGN;AACE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;AACJ;;AAGA;EACE,uBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,cCzDS;ADyDX;AAEE;EACE,cC5DO;ED6DP,eAAA;EACA,gBAAA;EACA,iBAAA;AAAJ;AAEI;EACE,sBAAA;AAAN;AAIE;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAFJ;AAKE;EACE,gBAAA;EACA,iBAAA;AAHJ;;AAQA;EACE,aAAA;EACA,8BAAA;AALF;AAOE;EACE,yBAAA;AALJ;;AAUA;EACE,WAAA;EACA,cAAA;AAPF;AASE;EACE,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cCtGO;AD+FX;AAUE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,8BAAA;AARJ;AAWE;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AATJ;AAWI;EACE,mBC7HK;ADoHX;AAWM;EACE,WAAA;AATR;AAaI;EACE,eAAA;EACA,iBAAA;AAXN;;AAgBA;EACE,WAAA;AAbF;AAcE;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cC7IO;ADiIX;;AAiBE;;EAEE,cCpJO;EDqJP,0BAAA;AAdJ;;AAkBA;EACE,UAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAfF;AAiBE;EACE,mBAAA;AAfJ;AAiBI;EACE,iBAAA;EACA,iBAAA;EACA,eAAA;AAfN;AAkBI;EACE,kBAAA;EACA,QAAA;AAhBN;AAmBI;EACE,0BAAA;AAjBN;AAoBI;EACE,oBAAA;EACA,kBAAA;AAlBN;AAoBM;EACE,SAAA;AAlBR;;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,UAAA;AArBF;AAuBE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cCzMO;ADoLX;;AAyBA;EACE,aAAA;EACA,qBAAA;AAtBF;AAwBE;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;EACA,mDAAA;EACA,sBAAA;EACA,mBAAA;EACA,0BAAA;AAtBJ;;AA0BA;EACE,cAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;EACA,cCpOS;AD6MX;;AA0BA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,cC3OS;ED4OT,gBAAA;EACA,oBAAA;AAvBF;;AA0BA;EACE,kBAAA;AAvBF;AAyBE;EACE,6BAAA;AAvBJ;;AA2BA;EACE;IACE,aAAA;EAxBF;EA4BE;IACE,kBAAA;IACA,mBAAA;EA1BJ;EA8BA;IACE,mBAAA;EA5BF;EA+BA;IACE,WAAA;EA7BF;AACF","sourcesContent":["@use 'styles/colors.scss';\n@use 'styles/sizes.scss';\n\n.response-message {\n  margin-bottom: 30px;\n}\n\n.card {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  border-radius: 12px;\n  border: 1px solid colors.$primary4;\n  background: #fff;\n  margin-bottom: 20px;\n}\n\n.card-top {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  padding: 12px 0;\n  border-radius: 12px 12px 0 0;\n  background: colors.$primary4;\n  color: #fff;\n\n  .price-description {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 36px;\n  }\n\n  .price-month {\n    position: relative;\n    font-weight: 400;\n    font-size: 28px;\n    line-height: 48px;\n\n    span {\n      font-weight: 600;\n      font-size: 52px;\n      line-height: 84px;\n    }\n  }\n\n  .price-year {\n    font-weight: 300;\n    font-size: 14px;\n    line-height: 24px;\n  }\n}\n\n.card-content {\n  padding: 16px 28px 20px;\n}\n\n.summary {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding-top: 8px;\n  border-radius: 12px;\n  color: colors.$primary8;\n\n  &-title {\n    color: colors.$primary8;\n    font-size: 16px;\n    font-weight: 500;\n    line-height: 28px;\n\n    svg{\n      vertical-align: middle;\n    }\n  }\n\n  &-description {\n    font-size: 16px;\n    font-weight: 300;\n    line-height: 28px;\n  }\n\n  &-start-date {\n    font-weight: 400;\n    margin-left: 25px;\n  }\n}\n\n\n.address {\n  display: flex;\n  justify-content: space-between;\n\n  &-link a{\n    color: colors.$primary4!important;\n  }\n}\n\n\n.payment {\n  width: 100%;\n  margin: 25px 0;\n\n  &-title {\n    margin-bottom: 16px;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 36px;\n    color: colors.$primary8;\n  }\n\n  &-methods {\n    display: grid;\n    grid-auto-flow: column;\n    gap: 12px;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  &-method {\n    padding: 20px 12px;\n    border-radius: 8px;\n    border: 1px solid colors.$primary2;\n    text-align: center;\n    background: #fff;\n    cursor: pointer;\n\n    &.selected {\n      background: colors.$primary4;\n\n      p {\n        color: #fff;\n      }\n    }\n\n    p {\n      font-size: 16px;\n      line-height: 28px;\n    }\n  }\n}\n\n.checkbox {\n  width: 100%;\n  &-label {\n    font-weight: 300;\n    font-size: 16px;\n    line-height: 28px;\n    color: colors.$primary8;\n  }\n}\n\n.link {\n  a,\n  a:visited {\n    color: colors.$primary8;\n    text-decoration: underline;\n  }\n}\n\n.collapsible{\n  padding: 0;\n  width: 100%;\n  font-size: 16px;\n  background: none;\n\n  div{\n    align-items: normal;\n\n    div{\n      position:initial;\n      margin-right: 5px;\n      margin-top: 3px;\n    }\n\n    > span{\n      position: absolute;\n      right: 0;\n    }\n\n    h4 span{\n      font-size: 16px!important;\n    }\n\n    &:last-child{\n      margin: 0!important;\n      padding-left: 25px;\n\n      ul{\n        margin: 0;\n      }\n    }\n  }\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 28px;\n  padding: 0;\n\n  &-title {\n    font-weight: 400;\n    font-size: 20px;\n    line-height: 1.5;\n    color: colors.$primary8;\n  }\n}\n\n.item {\n  display: flex;\n  align-items: baseline;\n\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 17px;\n    min-width: 17px;\n    height: 17px;\n    margin-right: 10px;\n    background: url(../../../assets/checkbox-circle.svg);\n    background-size: cover;\n    vertical-align: top;\n    transform: translateY(4px);\n  }\n}\n\n.payment-start{\n  display: block;\n  margin: -20px auto 20px auto;\n  font-size: 16px;\n  font-weight: 300;\n  color: colors.$primary8;\n}\n\n.legal-terms{\n  font-size: 10px;\n  font-weight: 300;\n  line-height: 16px;\n  color: colors.$primary8;\n  margin-top: 20px;\n  margin-bottom: -20px;\n}\n\n.offer{\n  padding: 20px 28px;\n\n  &:nth-child(3){\n    border-top: 1px solid colors.$primary4;\n  }\n}\n\n@media screen and (max-width: sizes.$breakpoint-sm) {\n  .card-content {\n    padding: 16px;\n  }\n\n  .payment {\n    &-method {\n      padding-left: 20px;\n      padding-right: 20px;\n    }\n  }\n\n  .inputs {\n    margin-bottom: 32px;\n  }\n\n  .button {\n    width: 100%;\n  }\n}\n","$primary1: #f5f5ff;\n$primary2: #d8d8ff;\n$primary3: #8686ff;\n$primary4: #4343ff;\n$primary5: #1414ff;\n$primary6: #0000c9;\n$primary7: #000093;\n$primary8: #00007a;\n$primary9: #000054;\n$primary10: #00003a;\n$primary11: #000078;\n$blueLogo: #000093;\n\n$neutral1: #fcfcfd;\n$neutral2: #f9f9fa;\n$neutral4: #e0e0e3;\n$neutral8: #838390;\n\n$success1: #f4fced;\n$success5: #58b441;\n$success6: #126f0e;\n\n$attention1: #fef9f0;\n$attention3: #fbd298;\n$attention5: #e78d3d;\n$attention7: #b94402;\n\n$danger1: #fdf1ed;\n$danger2: #f9d9cf;\n$danger3: #f4ada1;\n$danger5: #bd454a;\n$danger6: #911727;\n$danger7: #7c1028;\n\n\n$colabelNeutralLight: #F9F9FA;\n$colabelNeutralMid: #C3C3C9;\n$colabelNeutralDark: #121217;\n\n:export {\n    colabelNeutralLight: $colabelNeutralLight;\n    colabelNeutralMid: $colabelNeutralMid;\n    colabelNeutralDark: $colabelNeutralDark;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"response-message": `Summary_response-message__lvsYi`,
	"card": `Summary_card__nJ1DD`,
	"card-top": `Summary_card-top__+uCuN`,
	"price-description": `Summary_price-description__zYvzK`,
	"price-month": `Summary_price-month__Fmh9y`,
	"price-year": `Summary_price-year__MVFvi`,
	"card-content": `Summary_card-content__aChOt`,
	"summary": `Summary_summary__rpLY8`,
	"summary-title": `Summary_summary-title__t-DAI`,
	"summary-description": `Summary_summary-description__cGsWz`,
	"summary-start-date": `Summary_summary-start-date__wdfvT`,
	"address": `Summary_address__itBSB`,
	"address-link": `Summary_address-link__Yiw5b`,
	"payment": `Summary_payment__SuQAL`,
	"payment-title": `Summary_payment-title__nOQWk`,
	"payment-methods": `Summary_payment-methods__PhP+Z`,
	"payment-method": `Summary_payment-method__UrHXg`,
	"selected": `Summary_selected__xVU1u`,
	"checkbox": `Summary_checkbox__6LMly`,
	"checkbox-label": `Summary_checkbox-label__IrtcN`,
	"link": `Summary_link__20gJv`,
	"collapsible": `Summary_collapsible__sIwmU`,
	"list": `Summary_list__K-TaM`,
	"list-title": `Summary_list-title__LnW+w`,
	"item": `Summary_item__V4LbE`,
	"payment-start": `Summary_payment-start__39xjR`,
	"legal-terms": `Summary_legal-terms__kAA0J`,
	"offer": `Summary_offer__qy+sn`,
	"inputs": `Summary_inputs__k2g-G`,
	"button": `Summary_button__kqcfi`
};
export default ___CSS_LOADER_EXPORT___;
